import organizationPath from './organizationPath'

const tpaths = [...organizationPath];
export default tpaths;